<div class="container-fluid" [formGroup]="formGroup">
  <div class="d-flex flex-row justify-content-between">
    <h2 class="title">{{isEdit ? 'Edit Application Link' : 'Add Application Link'}}</h2>
    <div class="btn btn-primary d-flex justify-content-center align-items-center btn-save button" (click)="submit()">Save</div>
  </div>
  <div class="mt-3">
    <div class="col-12 text-normal p-0">Application Name
      <span style="color: red;">*</span>
    </div>
    <mat-form-field appearance="outline" class=" w-100">
      <input matInput required formControlName="name" placeholder="Enter Application Name" maxlength="50">
      <mat-hint align="end">{{formGroup.controls.name.value?.length || 0}} / 50</mat-hint>
      <mat-error class="mt-2">{{formGroup.controls.name.errors?.message}}</mat-error>
    </mat-form-field>
  </div>
  <div class="row">
    <div class="icon-avatar col-md-3 col-xl-2">
      <div class="img-avatar">
        <img src="{{urlIcon ? urlIcon : imgDefault}}" alt="" class="w-100 h-100" (click)="fileInput.click()">
      </div>
      <input type="file" hidden #fileInput (change)="onSelectFile($event)" accept=".png, .jpg, .jpeg">
      <button class="btn btn-primary button btn-remove" (click)="removeIcon()">Remove</button>
      <mat-error>{{errorMessage}}</mat-error>
    </div>
    <div class="col-md-9 col-xl-10 info-app" >
      <div class="col-12 text-normal p-0">URL
        <span style="color: red;">*</span>
      </div>
      <mat-form-field appearance="outline" class=" w-100">
        <input matInput required formControlName="url" placeholder="Enter URL" maxlength="512">
        <mat-hint align="end">{{formGroup.controls.url.value?.length || 0}} / 512</mat-hint>
        <mat-error class="mt-2">{{formGroup.controls.url.errors?.message}}</mat-error>
      </mat-form-field>
      <div class="col-12 text-normal p-0 mt-3">Description
        <span style="color: red;">*</span>
      </div>
      <mat-form-field appearance="outline" class=" w-100">
        <textarea matInput required formControlName="description" placeholder="Enter Description" style="height: 100px;"
        maxlength="512"></textarea>
        <mat-hint align="end">{{formGroup.controls.description.value?.length || 0}} / 512</mat-hint>
        <mat-error class="mt-2">{{formGroup.controls.description.errors?.message}}</mat-error>
      </mat-form-field>
    </div>
  </div>
</div>